import {
  ref,
  reactive,
  onBeforeMount,
  getCurrentInstance,
} from "@vue/composition-api";

import router from "@/router";
import store from "@/store";
import flashdealCampaignModel from "@/models/flashdeal/flashdeal-campaign";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";
import useFlatPickr from "@/utils/hooks/useFlatPickr";
import useModal from "@/@core/components/base-modal/hooks/useModal";

export default function userPrivilegeCampaignInfo() {
  const vm = getCurrentInstance().proxy;
  const {
    fetchFlashDealCampaignCreate,
    fetchFlashDealCampaignEdit,
    fetchFlashDealCampaignDetail,
  } = flashdealCampaignModel();
  const { openSuccessModal, openDefaultErrorModal } = useValidationModal();
  const { resolveDate, resolveTime, resolveReverseDate } = useFlatPickr();

  const { openModal, closeModal } = useModal();

  const form = reactive({
    campaignName: null,
    description: null,
    section: null,
    status: 0,
    validFrom: { date: null, time: null },
    validThrough: { date: null, time: null },
    image_1: { file: null, url: null },
  });

  const modalType = reactive({
    addPrivilege: false,
    editModal: false,
  });

  const isEdit = ref(false);

  const onOpenAddPrivilege = () => {
    modalType.editModal = false;
    modalType.addPrivilege = true;
    openModal();
  };

  const onCloseAddPrivilege = () => {
    modalType.addPrivilege = false;
    closeModal();
    vm.$refs.campaignEntryList.fetchEntryList();
  };

  const checkFormCreateOrEdit = () => {
    if (router.currentRoute.params.id) {
      isEdit.value = true;
      getCampaignDetail();
    }
  };

  const openEditModal = () => {
    modalType.editModal = true;
    vm.$bvModal.show("flashdeal-edit-privilege");
    openModal();
  };

  const closeEditModal = () => {
    vm.$bvModal.hide("flashdeal-edit-privilege");
  };

  const getCampaignDetail = () => {
    window.$loading(true);
    fetchFlashDealCampaignDetail.payload.Campaign_Id =
      router.currentRoute.params.id;
    store
      .dispatch("api/apiRequest", fetchFlashDealCampaignDetail)
      .then((response) => {
        let resp = response.data.campaign;
        form.campaignName = resp.name_th;
        form.description = resp.description_th;
        form.section = resp.section;
        form.status = resp.status == 1 ? true : false;
        form.validFrom.date = resolveDate(resp.valid_from);
        form.validFrom.time = resolveTime(resp.valid_from);
        form.validThrough.date = resolveDate(resp.valid_through);
        form.validThrough.time = resolveTime(resp.valid_through);
        form.image_1.url = resp.campaign_image_url;
      })
      .catch((error) => {
        openDefaultErrorModal(error);
      })
      .finally(() => {
        window.$loading(false);
      });
  };

  const onSubmitForm = () => {
    let payload = {
      Campaign_Name_Th: form.campaignName,
      Campaign_Name_En: form.campaignName,
      Campaign_Image_Url: form.image_1.file,
      Description_Th: form.description,
      Description_En: form.description,
      Section: form.section,
      Valid_From: resolveReverseDate(form.validFrom.date),
      Valid_From_Time: form.validFrom.time,
      Valid_Through: resolveReverseDate(form.validThrough.date),
      Valid_Through_Time: form.validThrough.time,
      Status: form.status ? 1 : 2,
    };

    if (!isEdit.value) return createCampaign(payload);

    payload.Campaign_Id = router.currentRoute.params.id;
    return editCampaign(payload);
  };

  const createCampaign = (payload) => {
    window.$loading(true);
    fetchFlashDealCampaignCreate.payload = payload;
    store
      .dispatch("api/apiFormRequest", fetchFlashDealCampaignCreate)
      .then((response) => {
        openSuccessModal(null, null, null, () =>
          router
            .replace({
              path:
                "/flashdeal/privilege/campaign/info/" +
                response.data.campaign.campaignid +
                "/" +
                response.data.campaign.alt_reference,
            })
            .catch(() => {})
        );
      })
      .catch((error) => {
        openDefaultErrorModal(error);
      })
      .finally(() => {
        window.$loading(false);
      });
  };

  const editCampaign = (payload) => {
    window.$loading(true);
    fetchFlashDealCampaignEdit.payload = payload;
    store
      .dispatch("api/apiFormRequest", fetchFlashDealCampaignEdit)
      .then((response) => {
        openSuccessModal(null, null, null, () => {});
      })
      .catch((error) => {
        openDefaultErrorModal(error);
      })
      .finally(() => {
        window.$loading(false);
      });
  };

  onBeforeMount(() => {
    checkFormCreateOrEdit();
  });

  return {
    form,
    modalType,
    isEdit,
    onOpenAddPrivilege,
    onCloseAddPrivilege,
    openEditModal,
    closeEditModal,
    onSubmitForm,
  };
}
